import { Button } from '@ibsys/kit';
import { FC } from 'react';
import { cn } from '@/shared/lib';

/**
 * Пропсы внутреннего компонента {@link AttachmentScrollButton}.
 */
type Props = {
  /** Готовая подпись времени — фразы или сообщения вложения. */
  timeLabel: string;
  /** Подпись для вспомогательных технологий: куда ведёт переход. */
  ariaLabel: string;
  /** Компактный режим — наследуем цвет текста родителя (для облака чата). */
  compact: boolean;
  /** Перейти к месту вложения в ленте. */
  onClick: () => void;
};

/** Время вложения в квадратных скобках; нажатие прокручивает ленту к месту вложения. */
export const AttachmentScrollButton: FC<Props> = ({ timeLabel, ariaLabel, compact, onClick }) => (
  <Button
    variant="ghost"
    size="sm"
    className={cn('shrink-0', compact ? 'text-current' : 'text-primary')}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {`[${timeLabel}]`}
  </Button>
);
